import { render, staticRenderFns } from "./CreateClaim.vue?vue&type=template&id=87cb5ef6&scoped=true"
import script from "./CreateClaim.vue?vue&type=script&lang=ts"
export * from "./CreateClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cb5ef6",
  null
  
)

export default component.exports